<template>
  <v-layout row wrap align-content-start fill-height class="pa-4">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">{{ $t('nurse.list') }}</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          :label="$t('common.search')"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getTechnicalStaffs.length > 0"
            :headers="headers"
            :items="getTechnicalStaffs"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
            :disable-initial-sort=true >


            <template slot="headers">
              <tr>
                <th
                  id="technicalStaff"
                  v-for="header in headers"
                  :key="header.text"
                  :class="['text-xs-left', 'column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <td>
                <v-edit-dialog
                  :return-value.sync="props.item.name"
                  lazy
                  @save="updateTechnicalStaff(props.item)"
                >
                  {{ props.item.name }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.name"
                      label="Edit Name"
                      single-line
                    />
                  </template>
                </v-edit-dialog>
              </td>
              <td>
                <v-edit-dialog
                  :return-value.sync="props.item.no"
                  lazy
                  @save="updateTechnicalStaff(props.item)"
                >
                  {{ props.item.no }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.no"
                      label="Edit No."
                      single-line
                    />
                  </template>
                </v-edit-dialog>
              </td>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addTechnicalStaff">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      {{ $t('nurse.added') }}
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminTechnicalStaffList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: this.$t('nurse.title'),
            align: 'left',
            value: 'name',
            // sortable: false
          },
          {
            text: 'Card No.',
            align: 'left',
            value: 'no',
            // sortable: false
          },
        ],
        snackbar: false,
        timeout: 3000,
      }
    },

    computed: {
      ...mapGetters('technicalStaffs', [
        'getTechnicalStaffs'
      ])
    },

    created () {
      this.fetchTechnicalStaffs()
    },

    methods: {
      ...mapActions('technicalStaffs', [
        'fetchTechnicalStaffs'
      ]),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('technicalStaffs/sortTechnicalStaffs', {title:column,order:this.pagination.order})

      },

      updateTechnicalStaff (item) {
        this.$store.dispatch('technicalStaffs/updateColumnById', item)
      },

      async addTechnicalStaff () {
        try {
          await this.$store.dispatch('technicalStaffs/addTechnicalStaff')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
    }
  }
</script>

<style lang="scss">
</style>